export default __webpack_public_path__ + "static/media/OpenSans-Regular.d7d7b835.ttf";